<template>
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle cx="10" cy="10" r="9" stroke="#222" stroke-width="2" />
		<circle
			cx="10"
			cy="10"
			r="9"
			stroke="#868686"
			stroke-width="2"
			:stroke-dasharray="circumference"
			:stroke-dashoffset="circumference * (1 - progress)"
			class="origin-center -scale-y-100 -rotate-90 transition-all duration-1000 ease-linear"
			:class="{ 'opacity-60': loading }"
		/>
	</svg>
</template>
<script setup lang="ts">
defineProps<{
	progress: number
	loading?: boolean
}>()

const circumference = 2 * Math.PI * 9 // ~56.55
</script>
